import { render, staticRenderFns } from "./BILL_RECEIVE.vue?vue&type=template&id=35a67ee3"
import script from "./BILL_RECEIVE.vue?vue&type=script&lang=js"
export * from "./BILL_RECEIVE.vue?vue&type=script&lang=js"
import style0 from "./BILL_RECEIVE.vue?vue&type=style&index=0&id=35a67ee3&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports